import { useTranslate } from "@tolgee/react";
import React from "react";
import * as Yup from "yup";
import { useUserData } from "../../auth/useUserData.js";
import { TextField } from "../../commons/form-fields/TextField.js";

export interface OrganisationMembershipInvitationEmailFormValues {
  message: string;
}

export function useOrganisationMembershipInvitationEmailForm() {
  const viewer = useUserData().currentUser!;
  const { t } = useTranslate(["OrganisationInvite"]);

  const validationSchema = React.useMemo(
    () =>
      Yup.object().shape({
        message: Yup.string()
          .label(
            t("Personal message", {
              ns: "OrganisationInvite",
            })
          )
          .required(),
      }),
    [t]
  );

  const initialValues: OrganisationMembershipInvitationEmailFormValues =
    React.useMemo(
      () => ({
        message: t(
          "Hello, Join our organisation {organisationName} on MeisterSystems. Kind regards, {senderName}",
          {
            ns: "OrganisationInvite",
            organisationName: viewer.organisation.title,
            senderName: (viewer.firstname + " " + viewer.familyname).trim(),
          }
        ),
      }),
      [t, viewer.familyname, viewer.firstname, viewer.organisation.title]
    );

  return {
    formFields: (
      <TextField
        label={t("Personal message", {
          ns: "OrganisationInvite",
        })}
        name="message"
        required
        multiline
        rows={8}
      />
    ),
    initialValues,
    validationSchema,
  };
}
